const skillData = [
{
    'name': "Front-End",
    'lang':'HTML, CSS, JavaScript, React'
    
},
{
    'name':'Back-End',
    'lang':'Express Js, Node Js, MongoDB'
},
{
    'name':'Tools',
    'lang': ' VS Code, GitHub, Netlify, Vercal '
}




]

export default skillData